import type { StatsViewModel } from "../utils/statsViewModel";
import { LineChart } from "./LineChart";

/** Styling for the dashed "previous period" line. */
const COMPARE_DATASET_STYLE = {
  borderColor: "rgba(134, 194, 235, .9)",
  backgroundColor: "transparent",
  borderDash: [5, 5],
  pointBackgroundColor: "transparent",
  pointRadius: 0,
};

/**
 * Renders a {@link StatsViewModel}'s `chartData` through the generic
 * {@link LineChart}, owning the dataset assembly and the compare-line styling
 * that the two detail views used to duplicate inline.
 */
export function StatsLineChart({
  data,
}: {
  data: StatsViewModel["chartData"];
}) {
  return (
    <LineChart
      data={{
        labels: data.labels,
        datasets: [
          { label: "Aktueller Zeitraum", data: data.current },
          data.compare && {
            label: "Vorheriger Zeitraum",
            data: data.compare,
            ...COMPARE_DATASET_STYLE,
          },
        ].filter(Boolean),
      }}
    />
  );
}
